var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabricks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 57 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5307 25.0543L28.4604 38.1391L3.91907 24.1976L2.75781 24.8206V34.9458L28.4604 49.5885L51.5307 36.5035V41.8776L28.4604 54.9626L3.91907 41.0209L2.75781 41.6441V43.3576L28.4604 58L54.2404 43.3576V33.2323L53.0792 32.6091L28.4604 46.5508L5.46735 33.4659V28.1697L28.4604 41.1767L54.2404 26.5341V16.5647L52.9243 15.8637L28.4604 29.7274L6.70597 17.3435L28.4604 5.03756L46.4211 15.1628L48.047 14.306V13.0598L28.4604 2L2.75781 16.5647V18.1224L28.4604 32.765L51.5307 19.6801V25.0543Z",
    fill: "#FF3621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricks);
export default __webpack_public_path__ + "static/media/databricks.0607c56896e389b4ebc56e4a26ba0a3b.svg";
export { ForwardRef as ReactComponent };